import { ArrowBack, ArrowForward, DarkMode, LightMode, MenuBook, SmartToy } from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";
import NoteZoom from "../editor-components/note-zoom";
import { memo, useCallback, useState } from "react";
import { Editor } from "@tiptap/react";
import { useSnackbar } from "../../../../../components/snackbar";

interface RightActionTabProps {
    editor: Editor;
    mode: number;
    setMode:  React.Dispatch<React.SetStateAction<number>>;
    noteZoom: number;
    setNoteZoom: React.Dispatch<React.SetStateAction<number>>;
    thirdBox: any;
    setThirdBox: React.Dispatch<React.SetStateAction<{
        visible: boolean;
        value: number;
    }>>;
}

function RightActionTab({ editor, mode, setMode, noteZoom, setNoteZoom, thirdBox, setThirdBox }: RightActionTabProps) {
    const { showMessage } = useSnackbar();

    const [isRightSidebarCollapsed, setIsRightSidebarCollapsed] = useState(false);

    const handleToggleRightSidebar = useCallback(() => {
        setIsRightSidebarCollapsed(prev => !prev);
    }, []);

    const toggleTheme = useCallback(() => {
        setMode(prev => prev === 1 ? 0 : 1);
    }, []);

    const toggleThirdBox = useCallback(() => {
        setThirdBox(prev => 
            prev.visible 
            ? { visible: false, value: 0 }
            : { visible: true, value: 2 }
        );
    }, []);
    
    return (
        <Box 
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: "100%",
                flexShrink: 0,
                flexGrow: 0,
                minWidth: '50px',
                overflow: 'hidden',
                transition: 'all 0.3s ease',
                justifyContent: 'space-between',
            }}
        >
            <Box 
                sx={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    overflowY: 'auto', 
                    width: '100%',
                    opacity: isRightSidebarCollapsed ? 0 : 1,
                    maxHeight: isRightSidebarCollapsed ? 0 : 600,
                    overflow: 'hidden',
                    transform: isRightSidebarCollapsed ? 'translateX(10px)' : 'translateX(0)',
                    transition: 'all 0.3s ease',
                    pointerEvents: isRightSidebarCollapsed ? 'none' : 'auto',
                    gap: 3,
                }}
            >
            <Tooltip title="AI Assistant" placement="left">
                <IconButton sx={{ color: '#4caf50' }} onClick={() => showMessage("coming soon!", 2)}><SmartToy /></IconButton>
            </Tooltip>
        
            <Tooltip title="Dictionary" placement="left">
                <IconButton 
                    sx={{ color: '#2196f3' }}
                    onClick={toggleThirdBox}
                >
                    <MenuBook />
                </IconButton>
            </Tooltip>
            
            <Tooltip title="Theme" placement="left">
                <IconButton onClick={toggleTheme}
                sx={{
                    color: mode === 0 ? "white" : "#121212"
                }}
                >
                { mode === 1 ? <DarkMode/> : <LightMode/> }
                </IconButton>
            </Tooltip>
                <NoteZoom editor={editor} noteZoom={noteZoom} setNoteZoom={setNoteZoom} mode={mode}/>
            </Box>
        
            <Tooltip title={isRightSidebarCollapsed ? 'Expand Menu' : 'Collapse Menu'}>
                <IconButton 
                    sx={{ 
                        width: 'fit-content', 
                        alignSelf: 'center',
                        color: mode === 0 ? "white" : "#121212"
                    }} 
                    onClick={handleToggleRightSidebar}
                >
                    {isRightSidebarCollapsed ? <ArrowBack/> : <ArrowForward/>}
                </IconButton>
            </Tooltip>
        </Box>
    );
}

export default memo(RightActionTab);
